import { CardValidationErrors } from '../types/error';

export const errorMessages = {
  WRONG_CREDENTIALS_ERROR: 'Incorrect email or password',
  EXPIRED_USER_INPUT_CODE_ERROR: 'Code expired',
  INCORRECT_USER_INPUT_CODE_ERROR: 'Incorrect code',
  RESTART_FLOW_ERROR: 'You have reached the maximum number of attempts',
  RESTART_FLOW_ERROR_SIGN_IN:
    'You’ve used all the attempts to enter the code. Try again or use another method',
  RESTART_FLOW_ERROR_SIGN_UP:
    'You’ve used all the attempts to enter the code. Try again or use another number',
  SIGN_IN_UP_NOT_ALLOWED: 'Authenticating is not allowed at this time',
  SIGN_IN_NOT_ALLOWED: 'You are not allowed to sign in at this time',
  SIGN_UP_NOT_ALLOWED: 'You are not allowed to sign up at this time',
  PASSWORD_RESET_NOT_ALLOWED: 'Password reset is not allowed at this time',
  RESET_PASSWORD_INVALID_TOKEN_ERROR: 'Token is invalid or expired',
};
export const CARD_ERROR_MESSAGES: CardValidationErrors = {
  emptyCardNumber: 'Enter a card number',
  invalidCardNumber: 'Card number is invalid',
  emptyExpiryDate: 'Enter a date',
  monthOutOfRange: 'Expiry month must be between 01 and 12',
  yearOutOfRange: 'Expiry year cannot be in the past',
  dateOutOfRange: 'Expiry date cannot be in the past',
  invalidExpiryDate: 'Expiry date is invalid',
  emptyCVC: 'Enter a CVC',
  invalidCVC: 'CVC is invalid',
};
export const replacedErrorMessages: Record<string, string> = {
  'This email already exists. Please sign in instead.':
    'This phone number already exists. Please sign in instead.',
};

export const BASE_OTP_LENGTH = 6;

export const ROUTES = {
  ROOT: '/',
  AUTH: '/auth',
  SIGN_UP: '/sign-up',
  RESET_PASSWORD: '/reset-password',
  WELCOME: '/welcome',
  NEW_PASSWORD: '/new-password',

  REGISTRATION: '/registration',
  KYB_QUESTIONNAIRE: '/onboarding',
  KYB_RESULT: '/kyb-result',

  PROFILE: '/profile',
  PAYMENTS: '/payments',
  CARDS: '/cards',
  CREATE_CARD: '/cards/create',
  ACCOUNT: '/account',
  CUSTOMIZE: '/customize',

  ANY: '*',
};

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

const PUBLIC_ROUTES = [
  ROUTES.AUTH,
  ROUTES.SIGN_UP,
  ROUTES.WELCOME,
  ROUTES.RESET_PASSWORD,
  ROUTES.NEW_PASSWORD,
];

export const isPublicRoute = (pathname: string) =>
  pathname.startsWith(ROUTES.WELCOME) || PUBLIC_ROUTES.includes(pathname);
